export default function Logo() {
  return <h1>⛱ VacayToGo 🧳</h1>;
}
